var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBike(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.391,
    height: 14,
    viewBox: "0 0 16.391 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    d: "M981.366,606.109A1.366,1.366,0,1,0,980,604.743,1.37,1.37,0,0,0,981.366,606.109Zm-7.171,4.439a3.415,3.415,0,1,0,3.415,3.415A3.381,3.381,0,0,0,974.2,610.548Zm0,5.8a2.39,2.39,0,1,1,2.39-2.39A2.42,2.42,0,0,1,974.2,616.353Zm3.961-6.829,1.639-1.639.546.547a4.776,4.776,0,0,0,2.7,1.379.686.686,0,0,0,.778-.683.694.694,0,0,0-.581-.676,3.427,3.427,0,0,1-1.878-.977l-1.3-1.3a1.676,1.676,0,0,0-1.093-.41,1.146,1.146,0,0,0-.956.41l-1.912,1.912a1.349,1.349,0,0,0-.41.956,1.146,1.146,0,0,0,.41.956l2.185,1.912v2.732a.683.683,0,1,0,1.366,0v-3a1.367,1.367,0,0,0-.376-.942Zm5.6,1.025a3.415,3.415,0,1,0,3.415,3.415A3.381,3.381,0,0,0,983.757,610.548Zm0,5.8a2.39,2.39,0,1,1,2.39-2.39A2.42,2.42,0,0,1,983.757,616.353Z",
    transform: "translate(-970.781 -603.377)",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBike);
export default __webpack_public_path__ + "static/media/bike.497c3bc6.svg";
export { ForwardRef as ReactComponent };